import useCartFromAPI from './apiLegacy/useCartFromAPI';
import useViewer from './useViewer';
import reactQueryClient from '@general/reactQueryClient';
import { resetFlashNotices } from '@general/helpers/cart.helpers';

const useCartClearFlashNoticesUpdateCart = () => {
    const { viewer } = useViewer();
    const { cart, refetch } = useCartFromAPI({ viewerId: viewer?.recordId });

    const clearFlashNoticesUpdateCart = async () => {
        await resetFlashNotices({ cart, viewer });
        // Get the updated cart
        const { data: updatedCart } = await refetch();

        // After clearing flash notices and refetching the cart, update the cart data in React Query
        reactQueryClient.setQueryData(`cart-${viewer.recordId}`, updatedCart);

        return updatedCart;
    };

    return { clearFlashNoticesRefetchCart: clearFlashNoticesUpdateCart };
};

export default useCartClearFlashNoticesUpdateCart;
